module.exports = __webpack_public_path__ + "img/91.c6c2779f.jpg";